var wercs = wercs || {};
wercs.Retailer = wercs.Retailer || {};
wercs.Retailer.Shared = wercs.Retailer.Shared || (function () {
	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function (searchString, position) {
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		};
	}

	var _shared = {},
		_IE = "";

	_shared.isIE = function () {
		return navigator.appName === 'Microsoft Internet Explorer' ||
			navigator.userAgent.indexOf('Edge/') > 0 ||
			navigator.appName === 'Netscape' && new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})").exec(navigator.userAgent) !== null;
	};

	if (_shared.isIE && /MSIE ([0-9]{1,}[.0-9]{0,})/.exec(navigator.userAgent) !== null) {
		_IE = parseFloat(RegExp.$1);
	}

	if (_shared.isIE && /rv\:([0-9]{1,}[.0-9]{0,})/.exec(navigator.userAgent) !== null) {
		_IE = parseFloat(RegExp.$1);
	}

	_shared.IE = function () {
		return _IE;
	};

	_shared.resizeGrid = function (gridID) {
		var grid = $("#" + gridID);
		var height = $(window).height() - $(grid).parent().parent().offset().top - 110;
		if (height < 225) height = 225;
		$(grid).jqGrid("setGridHeight", height);
	};

	_shared.delay = (function () {
		var timer = 0;
		return function (callback, ms) {
			clearTimeout(timer);
			timer = setTimeout(callback, ms);
		};
	})();

	_shared.displayItemSync = (function () {
		var menu = $("#ItemSyncMenu");
		if (menu.length === 0 || menu.is(":visible") === true) {
			return;
		}
		var promise = $.ajax({
			url: menu.attr("data-url"),
			type: "GET",
			dataType: "json",
			contentType: "application/json; charset=utf-8"
		});

		promise.done(function (display) {
			if (display === true) {
				menu.show();
			} else {
				menu.remove();
			}
		});
	})();

	_shared.debounce = function (func, delay, thisArg) {
		/// <summary>Returns a function that will delay invocation of the given function until it stops being invoked for the given time period</summary>
		/// <param name="func" type="Function" required="true">The function that to be invoked</param>
		/// <param name="delay" type="Integer" required="true">The amount of time to delay the function execution, in milliseconds</param>

		var timeout = null,
			firstInvocationTime,
			context,
			args,
			result,
			delayedFunction = function () {
				var remainingTime = Date.now() - firstInvocationTime;

				if (remainingTime < delay && remainingTime > 0) {
					window.clearTimeout(timeout);
					timeout = null;
					timeout = window.setTimeout(delayedFunction, delay - remainingTime);
				} else {
					window.clearTimeout(timeout);
					result = func.apply(context, args);

					args = timeout = null;
				}
			};

		return function () {
			args = Array.prototype.slice.call(arguments);

			if (thisArg === undefined) {
				context = this;
			} else {
				context = thisArg;
			}

			firstInvocationTime = Date.now();

			if (timeout === null) {
				timeout = window.setTimeout(delayedFunction, delay);
			}

			return result;
		};
	};

	return _shared;
}());

$(document).ready(function () {
	$.ajaxSetup({
		headers: {
			'__RequestVerificationToken': $('input[name="__RequestVerificationToken"]').val()
		},
		complete: function (x, status) {
			if (
				// (x.responseText.startsWith('<!DOCTYPE html>') && x.status === 200) ||
				x.status === 403
			) {
				// Standalone WebViewer visitors don't have a B2C account, so rootURL (which re-enters
				// through B2C) would just bounce them back here; WebViewerLogOnRedirectMiddleware sends
				// that viewer's own logon URL in X-Redirect-Url instead. When it's absent (the plain
				// RPS/B2C case), rootURL is correct and unchanged.
				window.location.href = x.getResponseHeader('X-Redirect-Url') || rootURL;
			}
		},
		cache: false
	});
});
